module.exports = __webpack_public_path__ + "static/media/22ESCWA4.3be91484.jpg";